<template>
  <div>
    <div class="borika-wrapper">
      <form method="POST" :action="formData.gateway_url">
        <input type="hidden" value="0001" name="Version" />
        <input name="MerchantID" type="hidden" :value="formData.merchantId" />
        <input name="TerminalID" type="hidden" :value="formData.terminalId" />
        <input name="TotalAmount" type="hidden" :value="formData.totalAmount" />
        <input name="Currency" type="hidden" :value="formData.currency" />
        <input type="hidden" value="bg" name="locale" />
        <input name="OrderID" type="hidden" :value="formData.orderId" />
        <input
          name="PurchaseTime"
          type="hidden"
          :value="formData.purchaseTime"
        />
        <input name="Signature" type="hidden" :value="formData.signature" />
        <v-btn lg block class="borika-btn" type="submit" :disabled="loading">
          <img
            src="/img/Raiffeisenbank-icon.svg"
            height="35"
            style="margin-right: 10px"
          />
          <img
            style="margin-right: 20px"
            src="/img/visa-logo.svg"
            height="35"
            alt=""
          />
          <img
            style="margin-right: 20px"
            src="/img/mastercard-logo.svg"
            height="35"
            alt=""
          />
          Плащане с Дебитна / Кредитна карта
        </v-btn>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RaiffeisenPaymentGateway',
  props: {
    gatewaySettings: {
      type: Object,
      required: true,
    },
    event: {
      type: Object,
      required: true,
    },
    secret: {
      required: true,
    },
    selectedTickets: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      formData: {
        gateway_url: '',
        version: '',
        merchantId: '',
        terminalId: '',
        totalAmount: '',
        currency: '',
        locale: '',
        orderId: '',
        purchaseTime: '',
        signature: '',
      },
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      axios
        .post(`/payment-gateway/rbb/redirect`, {
          secret: this.secret,
        })
        .then((response) => {
          this.formData = response.data
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.borika-wrapper {
  margin: 20px auto;
  max-width: 750px;

  .borika-btn {
    background-color: #c5cae9 !important;
    box-shadow: none !important;
    height: 60px !important;
  }
}
</style>
